<template>
	<section>
		<div v-if="packagingUnitsData.size > 0" class="wrapper" :style="{'grid-template-columns': `repeat(${this.leftAligned ? 2 : this.columns}, 1fr)`}">
			<template v-for="(columnMap, i) in columnMaps">
				<v-simple-table :key="i">
						<colgroup>
							<col style="width: 3rem"/>
							<col/>
							<col/>
						</colgroup>
					<tbody>
						<tr v-for="(packagingUnit, index) in columnMap.values()" :key="index">
							<td><v-icon size="24">{{ icons.boxOpen }}</v-icon></td>
							<td class="font-weight-bold">
								<span v-if="packagingUnit.quantity != null" style="font-size: 0.75rem">
									{{ `${packagingUnit.quantity} ${getUnitName(item.baseUnitOfMeasure)}` }}
								</span>
							</td>
							<td class="text-right">
								<span v-if="packagingUnit.quantity != null && packagingUnit.unitOfMeasure != null">
								      {{ getUnitName(packagingUnit.unitOfMeasure) }}
								</span>
								<span v-else>
									<v-icon>{{ icons.noData }}</v-icon>
								</span>
							</td>
						</tr>
					</tbody>
				</v-simple-table>
			</template>
		</div>
		<div v-else class="grey--text">
			{{ $t('item.packagingUnit.terms.noPackagingUnits') }}
		</div>
	</section>
</template>

<script lang="ts">
	import {Component, Prop, Vue} from 'vue-property-decorator';
	import {IItemShopListEntry} from "@/models/item/ItemShopModels";
	import Icon from "@/plugins/icons";
	import AsiAvatar from "@/components/common/AsiAvatar.vue";
	import {IPackagingUnit} from "@/models/packaging-unit/PackagingUnitModels";
	import EnumHelper from "@/helpers/EnumHelper";

	import {ItemAttributeVisibility, UnitOfMeasure} from "@/helpers/constants";
	import ItemHelper from "@/models/item/ItemHelper";
	import {IItemAdminListEntry} from "@/models/item/ItemAdminModels";

	@Component({
		components: {AsiAvatar}
	})
	export default class ItemPackagingUnits extends Vue {

		@Prop({type: Object, required: true})
		public item!: IItemShopListEntry | IItemAdminListEntry;

		@Prop({type: Number, default: 2})
		public columns!: number;

		@Prop({type: Boolean, default: false})
		public showAll!: boolean;

		@Prop({type: Boolean, default: false})
		public leftAligned!: boolean;

		private icons = Icon;

		private get packagingUnitsData() : Map<string, IPackagingUnit> {
			return ItemHelper.relevantPackagingUnits(this.item, ItemAttributeVisibility.detailViewOnly, false, this.showAll);
		}

		private getUnitName(unit: UnitOfMeasure): string | null {
			return EnumHelper.textFromValue(UnitOfMeasure, unit, true, 1);
		}

		private get columnMaps(): Map<string, IPackagingUnit>[] {
			const keys = Array.from(this.packagingUnitsData.keys());
			const columnSize = Math.ceil(keys.length / this.columns);

			const ret: Map<string, IPackagingUnit>[] = [];

			if (this.leftAligned){ return [this.packagingUnitsData]; }

			for (let i = 0; i < this.columns; i++) {
				const map = new Map<string, IPackagingUnit>();
				keys
					.slice(i * columnSize, i * columnSize + columnSize)
					.forEach(k => {
						let value = this.packagingUnitsData.get(k);

						return map.set(k, value as IPackagingUnit);
					});
				ret.push(map);
			}
			return ret;
		}
	}
</script>

<style scoped lang="scss">
	@import '../../../../node_modules/vuetify/src/styles/styles';

	.wrapper {
		display: grid;
		grid-gap: $spacer * 6;
	}

	tbody {
		tr:hover {
			background-color: transparent !important;
		}
	}

</style>
